export default __webpack_public_path__ + "static/media/barcode_circle.da97fd63.svg";